import React, { useEffect } from "react";
import Header from "../common/Header";
import Hero from "./hero/Hero";
import Projects from "./projects/Projects";
import Services from "./services/Services";
import Contact from "./contact/Contact";
import Skills from "./skills/Skills";
import Experience from "./experience/Experience";
import AchievementsAwards from "./achievements&awards/Achievements-Awards";

const Home = () => {
  useEffect(() => {
    // Set the 62.5% base font-size (1rem = 10px) only for the /home route
    document.documentElement.style.fontSize = "62.5%";
    return () => {
      document.documentElement.style.fontSize = "";
    };
  }, []);

  return (
    <>
      <Header />
      <section id="home">
        <Hero />
      </section>
      <section id="services">
        <Services />
      </section>
      <section id="projects">
        <Projects />
      </section>
      <section id="experience">
        <Experience />
      </section>
      <section id="a&a">
        <AchievementsAwards />
      </section>
      <section id="skills">
        <Skills />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </>
  );
};

export default Home;
